<!-- <mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  [(selectedIndex)]="currentActiveIndex"
>
  <mat-tab label="systemInfoes">
    <div style="width: 100%">
      <div style="width: 50%">
        <div class="d-flex w-100">
          <label for="">Host Name </label>
          <p>- {{ systemInfoDetails.hostname }}</p>
        </div>
        <div class="d-flex w-100">
          <label for="">Internet Connection </label>
          <p>- {{ systemInfoDetails.internetConnection }}</p>
        </div>
        <div class="d-flex w-100">
          <label for="">Operating System</label>
          <p>
            - {{ systemInfoDetails.operatingSystem.name }} ({{
              systemInfoDetails.operatingSystem.version
            }})
          </p>
        </div>
        <div class="d-flex w-100">
          <label for="">Up Time </label>
          <p>- {{ systemInfoDetails.uptime }}</p>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group> -->

<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  [(selectedIndex)]="currentActiveIndex"
>
  <mat-tab label="System Details" class="p-1">
    <app-health-system-info />
  </mat-tab>
  <mat-tab label="Services" class="p-1"> <app-health-services /> </mat-tab>
  <mat-tab label="Network" class="p-1"><app-health-network /></mat-tab>
  <mat-tab label="Log" class="p-1"> <app-health-logs /> </mat-tab>
</mat-tab-group>
